module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.goOrderDetail
    }
  }, [_c('div', {
    staticClass: "justify-between detail-header"
  }, [_c('div', {
    staticClass: "text_7"
  }, [(_vm.carDetails.orderState == 2) ? _c('van-count-down', {
    staticClass: "text_7",
    attrs: {
      "time": _vm.time,
      "format": "剩余 DD天 HH:mm:ss"
    }
  }) : _c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("\n                支付时间: " + _vm._s(_vm.carDetails.payTime) + "\n            ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "text_9",
    style: (_vm.getFontColor(_vm.carDetails.orderStateDesc))
  }, [_vm._v(_vm._s(_vm.carDetails.orderStateDesc))])]), _vm._v(" "), _c('CarCard', {
    attrs: {
      "carDetails": _vm.carDetails,
      "current": "order"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "justify-between group_9"
  }, [_c('div', {
    staticClass: "flex-row group_10"
  }, [_c('div', [_c('span', {
    staticClass: "text_17"
  }, [_vm._v(_vm._s(_vm.carDetails.orderState == 2 ? "需" : "已") + "支付定金")]), _vm._v(" "), _c('span', {
    staticClass: "text_19"
  }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
    staticClass: "text_21"
  }, [_vm._v(_vm._s(_vm.carDetails.depositPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row group_11 view_7"
  }, [_c('div', {
    staticClass: "flex-col items-center text-wrapper_5 orderBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.callCustomer.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                联系专员\n            ")]), _vm._v(" "), (_vm.carDetails.orderState == 2) ? _c('div', {
    staticClass: "flex-col items-center text-wrapper_6 orderBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPay.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                立即支付\n            ")]) : _vm._e(), _vm._v(" "), (_vm.carDetails.orderState == 3) ? _c('div', {
    staticClass: "flex-col items-center text-wrapper_7 orderBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goGetCoupon.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                我的权益\n            ")]) : _vm._e()])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-704ecba8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-704ecba8","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/_components/CarCardForOrderList.vue
// module id = 281
// module chunks = 320 321